
export default () => ({
  container: {
    width: '100%'
  }
});
